import { DOCUMENT, Injectable, inject } from '@angular/core';

/**
 * Salir de la aplicacion hacia una direccion que no es del `Router`.
 *
 * Hoy tiene un solo consumidor —el checkout del middleware de pagos, al que la
 * ruta reentrante devuelve un pago empezado (SPEC-010, AC-12)— y existe por una
 * razon concreta: escribir `location.href` dentro de un componente hace que la
 * prueba de ese componente **navegue de verdad** y se lleve por delante al
 * corredor de pruebas. Con esto se sustituye.
 *
 * Se usa `assign` y no `replace`: el boton de atras del navegador tiene que
 * poder devolver a la pantalla del tramite.
 */
@Injectable({ providedIn: 'root' })
export class SalidaExterna {
  private readonly ventana = inject(DOCUMENT).defaultView;

  ir(url: string): void {
    this.ventana?.location.assign(url);
  }
}
